<div class="notif-panel">

  <!-- Header -->
  <div class="notif-header">
    <span class="notif-title">Notifications</span>
    <div class="notif-header-actions">
      <button
        *ngIf="(unreadCount() | async) !== null"
        class="notif-action-btn"
        (click)="markAllRead()">
        Mark all read
      </button>
      <button
        *ngIf="(unreadCount() | async) !== null"
        class="notif-action-btn clear-btn"
        (click)="clearAll()">
        Clear all
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="notif-body">

    <!-- Empty state -->
    <div *ngIf="(notifications$ | async)?.length === 0" class="notif-empty">
      <span class="pi pi-bell" style="font-size:28px; color:var(--tp-surface-200);"></span>
      <p>No notifications</p>
    </div>

    <!-- Notification items -->
    <div
      *ngFor="let item of notifications$ | async"
      class="notif-item"
      [class.unread]="!item.isRead"
      (click)="markAsRead(item.id)">
      <span
        [ngClass]="iconFor(item.type)"
        [style.color]="iconColorFor(item.type)"
        class="notif-icon">
      </span>
      <div class="notif-content">
        <p class="notif-message">{{ item.body }}</p>
        <p class="notif-time">{{ item.createdAt | date:'MMM d · h:mm a' }}</p>
      </div>
      <span *ngIf="!item.isRead" class="unread-dot"></span>
    </div>

  </div>
</div>
